import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

/**
 * Componente para proteger rutas sensibles con un código temporal (PIN).
 * No guarda nada en localStorage/sessionStorage, solo en memoria.
 * Si el usuario refresca o cierra la pestaña, deberá volver a ingresar el código.
 */
const ProtectedByCodeRoute = ({ children, requiredCode = '1234', label = 'Ingrese el código de acceso' }) => {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [input, setInput] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input === requiredCode) {
      setIsAuthorized(true);
      setError('');
    } else {
      setError('Código incorrecto');
      setInput('');
    }
  };

  if (isAuthorized) return children;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <form
        onSubmit={handleSubmit}
        className="bg-white rounded-xl shadow-lg p-8 flex flex-col gap-4 min-w-[300px] border border-gray-200 relative"
        autoComplete="off"
      >
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="absolute left-4 top-4 text-gray-400 hover:text-indigo-600 focus:outline-none"
          title="Volver"
        >
          <FaArrowLeft size={22} />
        </button>
        <h2 className="text-xl font-bold text-center text-gray-800 mb-2">Área protegida</h2>
        <label className="text-sm text-gray-600 text-center mb-2">{label}</label>
        <input
          type="password"
          value={input}
          onChange={e => setInput(e.target.value)}
          className="border border-gray-300 rounded-lg px-4 py-2 text-center text-lg focus:ring-2 focus:ring-indigo-400 outline-none"
          autoFocus
          maxLength={12}
        />
        {error && <div className="text-red-500 text-center text-sm font-semibold">{error}</div>}
        <button
          type="submit"
          className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 rounded-lg shadow transition-all"
        >
          Acceder
        </button>
      </form>
    </div>
  );
};

export default ProtectedByCodeRoute;
